import { ContentActionItemType, } from '@office-start/document-types';
import React from 'react';
import { ActionCommandMenuItem } from './ActionCommandMenuItem';
import { groupDocumentActions } from './util';
export var ActionCommandMenu = function (_a) {
    var commandItems = _a.commandItems, groupInfo = _a.groupInfo, onCommandMenuToggled = _a.onCommandMenuToggled;
    var groupedCommandItems = groupDocumentActions(commandItems, groupInfo);
    return (React.createElement(React.Fragment, null, groupedCommandItems
        .filter(function (menuInfo) {
        var _a;
        return ((_a = menuInfo.contentActionOptions) === null || _a === void 0 ? void 0 : _a.itemType) !==
            ContentActionItemType.Divider;
    })
        .map(function (documentAction) {
        return (React.createElement(ActionCommandMenuItem, { documentAction: documentAction, onCommandMenuToggled: onCommandMenuToggled, key: documentAction.id }));
    })));
};
//# sourceMappingURL=ActionCommandMenu.js.map